import { render, staticRenderFns } from "./touchscreen-compatible.vue?vue&type=template&id=cb06816c&"
import script from "./touchscreen-compatible.vue?vue&type=script&lang=js&"
export * from "./touchscreen-compatible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports